<div class="popover-send-code">
  <p class="typo-20-semibold-green"> Un nouveau code de vérification vient de vous être envoyé.</p>
</div>

